import {
	orderEditSlice,
	ordersListSlice,
	NewRequestModal,
	outOfficeRegistratorCabinetSlice,
	APPOINTMENT_ERROR_MESSAGE,
} from 'Pages/registratorCabinet'
import { MODAL_NAME } from 'Constants/ModalName'
import { RequestParams } from 'Models'
import { modalsSlice } from 'Modules'
import { Callback } from 'Src/types/utilTypes'
import {
	ChannelHandler,
	SocketMessage,
	SocketMessageTypes,
	errorResponse,
	formErrorResponse,
} from 'Modules/Socket'

export class RbidosRequestChannel implements ChannelHandler {
	public constructor(private readonly dispatch: Callback) {
		this.dispatch = dispatch
	}
	public work(data: SocketMessage): void {
		const { message } = data
		const type = message?.type
		const cities = message?.payload?.cities_response
		const find_by_date_range_response = message?.payload?.find_by_date_range_response
		const create_appointment_for_rbidos_response =
			message?.payload?.create_appointment_for_rbidos_response
		const id = message?.payload?.request_id

		const errorResponseAppointment = (value) => {
			const errorMessageParsed = JSON.parse(value)?.errorMessage
			const idParsed = JSON.parse(value)?.id
			const allowedAppointmentCases =
				errorMessageParsed === APPOINTMENT_ERROR_MESSAGE.NO_TICKETS ||
				errorMessageParsed?.includes(APPOINTMENT_ERROR_MESSAGE.NO_SLOTS) ||
				idParsed
			return !allowedAppointmentCases
		}

		if (type === SocketMessageTypes.CITIES_RESPONSE && cities) {
			if (errorResponse(cities)) {
				this.dispatch(outOfficeRegistratorCabinetSlice.actions.errorNotificationResponse())
			} else {
				this.dispatch(outOfficeRegistratorCabinetSlice.actions.setRegionsCities(JSON.parse(cities)))
			}
		}
		if (type === SocketMessageTypes.FIND_BY_DATE_RANGE_RESPONSE && find_by_date_range_response) {
			if (errorResponse(find_by_date_range_response)) {
				this.dispatch(outOfficeRegistratorCabinetSlice.actions.errorNotificationResponse())
			} else if (formErrorResponse(find_by_date_range_response)) {
				this.dispatch(
					outOfficeRegistratorCabinetSlice.actions.setFormError(
						JSON.parse(find_by_date_range_response)?.businessErrorCode
					)
				)
			} else {
				this.dispatch(
					outOfficeRegistratorCabinetSlice.actions.setSlots({
						value: JSON.parse(find_by_date_range_response)?.slots,
						id: id.toString(),
					})
				)
			}
		}
		if (
			type === SocketMessageTypes.CREATE_APPOINTMENT_FOR_RBIDOS_RESPONSE &&
			create_appointment_for_rbidos_response
		) {
			if (errorResponseAppointment(create_appointment_for_rbidos_response)) {
				this.dispatch(outOfficeRegistratorCabinetSlice.actions.errorNotificationResponse())
			} else {
				this.dispatch(
					outOfficeRegistratorCabinetSlice.actions.setAppointment({
						value: create_appointment_for_rbidos_response,
						id,
					})
				)
			}
		}

		if (type === SocketMessageTypes.NEW_REQUEST && id) {
			this.dispatch(orderEditSlice.actions.pushSocketId({ id }))
			this.dispatch(orderEditSlice.actions.getSocket({ id }))
			this.dispatch(ordersListSlice.actions.getAll({ params: new RequestParams(), clear: true }))
			this.dispatch(
				modalsSlice.actions.showModal({
					Component: NewRequestModal,
					key: MODAL_NAME.SOCKET_RBIDOS_REQUEST,
				})
			)
		} else if (type === SocketMessageTypes.UPDATE && id) {
			this.dispatch(orderEditSlice.actions.updateSocketId({ id }))
		}
	}
}
